import { VehicleType } from '../service-proxies';


export class FuelAllowanceDto implements IFuelAllowanceDto {
    id!: number;
    vehicleTypeId!: VehicleType;
    vehicleTypeName!: string | undefined;
    fromDate!: Date;
    toDate!: Date;
    amountPerKM!: number;

    constructor(data?: IFuelAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.amountPerKM = _data["amountPerKM"];
        }
    }

    static fromJS(data: any): FuelAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["amountPerKM"] = this.amountPerKM;
        return data; 
    }
}

export interface IFuelAllowanceDto {
    id: number;
    vehicleTypeId: VehicleType;
    vehicleTypeName: string | undefined;
    fromDate: Date;
    toDate: Date;
    amountPerKM: number;
}

